import React, { useRef, useImperativeHandle } from 'react';
import { StripeElementChangeEvent } from '@stripe/stripe-js';

// @ts-ignore
const StripeInput = ({ component: Component, inputRef, textColor, updateStripeInputState, ...props }) => {
  const elementRef = useRef();

  useImperativeHandle(inputRef, () => ({
    // @ts-ignore
    focus: () => elementRef?.current?.focus as never,
  }));

  const onChangeCardElement = (stripeField: StripeElementChangeEvent) => {
    updateStripeInputState(stripeField);
  };

  return (
    <Component
      options={{
        placeholder: '',
        style: {
          base: {
            fontSize: '16px',
            color: '#263245',
          },
          empty: {

            ':-webkit-autofill': {
            },
          },
        },
      }}

      // @ts-ignore
      onReady={(element) => (elementRef.current = element)}

      {...props}
      onChange={onChangeCardElement}
    />
  );
};

export default StripeInput;
